export default "__VITE_ASSET__1gxsIB0a__"